import { useEffect, useState } from 'react';
import FormHelperText from '@material-ui/core/FormHelperText';
import { useMissingFieldError } from './ProductValidationContext';
import { ProductRuleFieldType } from './type';
import AiFieldVerdict from '../AiFieldVerdict';

/**
 * Red helper text under a required question that has no text input of its own (radio groups, uploads, trees),
 * matching the error text the base required fields show. Appears once focus has left the element with id={field}.
 */
// hideAiVerdict: the field shows the failed AI review verdict itself, e.g. below its row.
const MissingFieldHint = ({ field, hideAiVerdict }: { field: ProductRuleFieldType; hideAiVerdict?: boolean }) => {
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (touched) return;
    const onFocusOut = (event: FocusEvent) => {
      const target = event.target as HTMLElement | null;
      if (target?.closest?.(`[id="${field}"]`)) setTouched(true);
    };
    document.addEventListener('focusout', onFocusOut, true);
    return () => document.removeEventListener('focusout', onFocusOut, true);
  }, [field, touched]);

  const error = useMissingFieldError(field, touched);
  return (
    <>
      {error && (
        <FormHelperText error data-missing-field={field}>
          {error}
        </FormHelperText>
      )}
      {/* Superusers see a failed AI review verdict here too, as these fields have no text input. */}
      {!hideAiVerdict && <AiFieldVerdict field={field} />}
    </>
  );
};

export default MissingFieldHint;
